// removed by extract-text-webpack-plugin
module.exports = {"container":"event-details-page__container__2Tn33","spacer":"event-details-page__spacer__Lt3bx","download-app-banner-container":"event-details-page__download-app-banner-container__2BC74","legal-notice-container":"event-details-page__legal-notice-container__pA4Lq","download-app-banner":"event-details-page__download-app-banner__3Nf-k","event-detail-flier":"event-details-page__event-detail-flier__21ZCK","event-section-handler":"event-details-page__event-section-handler__1jLPY"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/event-details-page.scss
// module id = 629
// module chunks = 1